/**
 * i18n configuration
 */

import i18n from 'i18next'
import {
    initReactI18next,
} from 'react-i18next'
import {
    cs,
} from '../../shared/lang/cs'
import {
    en,
} from '../../shared/lang/en'

i18n
    .use(initReactI18next)
    .init({
        resources: {
            cs: {
                translation: cs,
            },
            en: {
                translation: en,
            },
        },
        lng: localStorage.getItem('language') || 'cs',
        fallbackLng: 'cs',
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
